/**
 * data/otherServices.js — iter250 → iter297
 *
 * Single source of truth for the "بوابة مزودي الخدمات" hub. Adding a
 * section stays a one-line change: append an object here and it flows
 * automatically into (1) the /other-services grid, (2) the
 * ProviderDirectoryPage for that route, (3) the admin panel category
 * picker.
 *
 * `iconType` maps to <GoldServiceIcon type="…" /> — a bespoke SVG set
 * so these tiles never look like the default lucide-react library.
 *
 * iter297 — AR copy realigned with the official hub spec:
 *   1. النقل — «خدمات نقل المركبات داخل المدن وبين مناطق المملكة»
 *   2. مراكز الصيانة — «مراكز الصيانة والإصلاح والخدمات الفنية للمركبات»
 *   3. مراكز العناية — «خدمات العناية بالمركبات مثل الغسيل والتلميع والتجهيز»
 * Order in this array = order in the grid, so future additions append
 * without touching the header or the tile component.
 */
export const OTHER_SERVICES = [
  {
    id: "vehicle_transport",
    category: "delivery",
    iconType: "truck",
    to: "/delivery",
    ar: {
      title: "النقل",
      desc: "خدمات نقل المركبات داخل المدن وبين مناطق المملكة.",
    },
    en: {
      title: "Vehicle transport",
      desc: "Move your vehicle across cities and regions of the Kingdom.",
    },
    testid: "other-vehicle-transport",
  },
  {
    id: "comprehensive_maintenance",
    category: "workshop",
    iconType: "wrench",
    to: "/workshop",
    ar: {
      title: "مراكز الصيانة",
      desc: "مراكز الصيانة والإصلاح والخدمات الفنية للمركبات.",
    },
    en: {
      title: "Service centres",
      desc: "Maintenance, repair, and technical services for vehicles.",
    },
    testid: "other-comprehensive-maintenance",
  },
  {
    id: "car_care",
    category: "car_wash",
    iconType: "care",
    to: "/car-wash",
    ar: {
      title: "مراكز العناية",
      desc: "خدمات العناية بالمركبات مثل الغسيل والتلميع والتجهيز.",
    },
    en: {
      title: "Care centres",
      desc: "Wash, polish, and detailing services for your vehicle.",
    },
    testid: "other-car-care",
  },
];

/** Convenience lookup by category slug (used by ProviderDirectoryPage). */
export const OTHER_SERVICES_BY_CATEGORY = Object.fromEntries(
  OTHER_SERVICES.map((s) => [s.category, s])
);
